import React from "react";
import { produce } from "immer";
import { FilterDefinition, Menu, SearchBar, Select } from "@sscs/ui";
import { FileStreamFilter } from "../../types";

const searchBarProps: Partial<React.ComponentProps<typeof SearchBar>> = {
  variant: "outlined",
  fullWidth: true,
  slotProps: { htmlInput: { maxLength: 256 } },
  debounceTimer: 250,
};

export const getFileStreamFilters = (
  filter: FileStreamFilter,
  onChange: (filter: FileStreamFilter) => void,
): FilterDefinition[] => {
  const filterUploadsValue =
    filter.deleted_in_days !== null ? filter.deleted_in_days : filter.user;

  const handleUploadsFilterChange = (value: string) => {
    onChange(
      ["MY", "ALL"].includes(value)
        ? produce(filter, (draft) => {
            draft.user = value;
            draft.deleted_in_days = null;
          })
        : produce(filter, (draft) => {
            draft.deleted_in_days = parseInt(value);
            draft.user = "ALL";
          }),
    );
  };

  return [
    {
      id: "uploads",
      width: "175px",
      control: (
        <Select
          id="filter-uploads"
          aria-label="Uploads"
          value={filterUploadsValue}
          onChange={handleUploadsFilterChange}
          variant="outlined"
        >
          <Menu.Item id="all-uploads" value="ALL">
            All uploads
          </Menu.Item>
          <Menu.Item id="my-uploads" value="MY" divider>
            My uploads
          </Menu.Item>
          <Menu.Item id="deleted-in-7-days" value="7">
            Removing in 7 days
          </Menu.Item>
          <Menu.Item id="deleted-in-30-days" value="30">
            Removing in 30 days
          </Menu.Item>
          <Menu.Item id="deleted-in-60-days" value="60">
            Removing in 60 days
          </Menu.Item>
        </Select>
      ),
    },
    {
      id: "approval",
      width: "200px",
      control: (
        <Select
          id="filter-approval"
          aria-label="Approval status"
          value={filter.approval_status}
          onChange={(value: FileStreamFilter["approval_status"]) =>
            onChange(
              produce(filter, (draft) => {
                draft.approval_status = value;
              }),
            )
          }
          variant="outlined"
        >
          <Menu.Item id="filter-approval-status-all" value="ALL">
            All approval statuses
          </Menu.Item>
          <Menu.Item
            id="filter-approval-status-undetermined"
            value="Undetermined"
          >
            Requires approval
          </Menu.Item>
          <Menu.Item id="filter-approval-status-approved" value="Approved">
            Approved software
          </Menu.Item>
          <Menu.Item
            id="filter-approval-status-rejected"
            value="ApprovalRejected"
          >
            Approval rejected
          </Menu.Item>
          <Menu.Item
            id="filter-approval-status-revoked"
            value="ApprovalRevoked"
          >
            Approval revoked
          </Menu.Item>
        </Select>
      ),
    },
    {
      id: "file-name",
      width: "280px",
      control: (
        <SearchBar
          id="filter-files"
          label="Regex search for file name"
          value={filter.file_name}
          onChange={(value) => {
            onChange(
              produce(filter, (draft) => {
                draft.file_name = value;
              }),
            );
          }}
          {...searchBarProps}
        />
      ),
    },
  ];
};
